<button type="button" [tooltip]="tooltipMensaje" [options]="tooltipOptions" (click)="onClick($event)" [ngClass]="classBtn">
    <i [class]="iconBtn"></i>
    {{labelBtn}}
</button>
